<template>
  <v-layout
    row
    wrap
    class="pa-4"
  >
    <v-flex xs12>
      <Toggle
        v-model="badge.print_badge"
        title="Print Badges"
        caption="Let Kiosk print badges for visitors"
        @change="updateBadge"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import _cloneDeep from 'lodash/cloneDeep';

import Toggle from '@/components/common/Toggle';

export default {
  name: 'Badge',
  components: {
    Toggle
  },
  props: {
    data: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      badge: {}
    };
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.badge = _cloneDeep(val);
      },
      immediate: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.badge, validation]);
  },
  methods: {
    updateBadge(val) {
      this.badge.print_badge = val;
    }
  }
};
</script>

